import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { AuthShell, Field, Divider } from "@/pages/Login";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

const inputCls = "w-full bg-navy border border-white/20 text-white p-3 focus:border-gold focus:outline-none";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/portal", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Access your projects, proposals, and downloads.">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        {error && <div className="bg-destructive/15 border border-destructive/40 text-red-300 text-sm px-4 py-3" data-testid="register-error">{error}</div>}
        <Field label="Full name">
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" className={inputCls} placeholder="Jane Doe" />
        </Field>
        <Field label="Email">
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" className={inputCls} placeholder="you@company.com" />
        </Field>
        <Field label="Password">
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" className={inputCls} placeholder="At least 6 characters" />
        </Field>
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-gold text-navy py-4 font-semibold hover:bg-gold-light transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="animate-spin" size={18} />} Create Account
        </button>
      </form>
      <Divider />
      <button onClick={googleLogin} data-testid="google-register-btn"
        className="w-full border border-white/20 text-white py-4 font-medium hover:bg-white/5 transition-colors flex items-center justify-center gap-3">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
        Continue with Google
      </button>
      <p className="text-center text-gray-400 text-sm mt-6">
        Already have an account? <Link to="/login" className="text-gold hover:underline" data-testid="go-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
